module.exports = __webpack_public_path__ + "assets/img/forbidden.4035ea1c.png";